import { CenterEvent } from '../../../lib/types/models/center-event/center-event'
import PeriodBadge from '../../elements/period-badge'

type Props = {
  centerEvent: CenterEvent
}

const CenterPeriodCell = ({ centerEvent }: Props) => {
  if (!centerEvent.centerPeriod) return '-'

  return <PeriodBadge period={centerEvent.centerPeriod} />
}

export default CenterPeriodCell
